/**
 * The browser's native `fetch`, captured at module-eval time — BEFORE Amplitude
 * Session Replay (or any recorder) can wrap `window.fetch`.
 *
 * Why this exists: Session Replay's network observer replaces `window.fetch`
 * and, to record the response body, does `response.clone().text()`. Cloning and
 * fully reading a long-lived STREAMING response (our chat answer stream) stalls
 * / consumes the body, so the app's own `getReader()` gets nothing and the
 * assistant bubble renders EMPTY. That regression only hit replay-active (USA)
 * users.
 *
 * Streaming requests must therefore use this unwrapped reference. Bonus: it also
 * stops the recorder from capturing sensitive request/response payloads for
 * those calls.
 *
 * This module is imported at the very top of `index.tsx` so the capture happens
 * at startup — long before the (lazily added) replay plugin wraps fetch. Being a
 * singleton, any later importer (e.g. the lazily-loaded ChatPage) receives this
 * same early-captured reference.
 */
const nativeFetch: typeof fetch =
  typeof window !== "undefined" && typeof window.fetch === "function"
    ? window.fetch.bind(window)
    : fetch;

export default nativeFetch;
